import {setSaveStatusError} from 'redux/actions'
import {RestRequestBLOBBase64Encoded, RestRequestGET} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import Tr from 'translations/Translations';

const KYS_REPORT_FILE_NAME = 'Weryfikacja kys.pdf';

const downloadBlobAsFile = (blob, fileName) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
};

const generateReport = async (url, id, contractorNIP) => {
    try {
        const resp = await RestRequestBLOBBase64Encoded(
            url,
            {
                headers: { Accept: 'application/pdf, application/json' }
            }
        );
        if (!resp) {
            reduxStore.dispatch(setSaveStatusError(Tr('unknown_error_message')));
            return;
        }
        if (resp.success !== true) {
            let errorMessage = Tr('unknown_error_message');

            if (resp.errors) {
                if (Array.isArray(resp.errors) && resp.errors.length > 0) {
                    errorMessage = Tr(resp.errors[0]);
                } else if (typeof resp.errors === 'object') {
                    const firstError = Object.values(resp.errors)[0];
                    if (Array.isArray(firstError) && firstError.length > 0) {
                        errorMessage = Tr(firstError[0]);
                    } else if (firstError) {
                        errorMessage = Tr(firstError);
                    }
                } else if (typeof resp.errors === 'string') {
                    errorMessage = Tr(resp.errors);
                }
            }
            reduxStore.dispatch(setSaveStatusError(errorMessage));
            return;
        }

        if (!resp.result) {
            reduxStore.dispatch(setSaveStatusError(Tr('unknown_error_message')));
            return;
        }

        const pdfBytes = window.atob(resp.result);
        const len = pdfBytes.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = pdfBytes.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');

        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
    } catch (e) {
        reduxStore.dispatch(setSaveStatusError(Tr('unknown_error_message')));
    }
};

const getReportHistory = async (url, id, contractorNIP) => {
    try {
        return await RestRequestGET(url);
    } catch (error) {
    }
};

const downloadReport = async (url, id, reportId) => {
        try {
            const resp = await RestRequestGET(
                url,
                {
                    responseType: 'blob',
                    headers: { Accept: 'application/pdf' }
                }
            );

            if (!resp) {
                return;
            }
            const blob = resp instanceof Blob ? resp : new Blob([resp], { type: 'application/pdf' });
            if (blob.size === 0) {
                return;
            }
            downloadBlobAsFile(blob, KYS_REPORT_FILE_NAME);
        } catch (e) {
            console.error("Error:", e);
        }
};

export default {
    generateReport,
    downloadReport,
    getReportHistory
}